import { QualityReviewsByShipmentIdsQuery } from "@api/graphql/generated/generated-types";

export type QualityReview = QualityReviewsByShipmentIdsQuery["qualityReviewsByShipmentIds"][number];
export type QualityReviewItem = QualityReview["items"][number];
export type QualityReviewPrice = QualityReview["price"];

/**
 * Enum representing the quality review state for a specific order.
 * Used to highlight the quality review status visibly on the orders page.
 */
export enum QualityReviewState {
  None = "none",
  Good = "good",
  Warning = "warning",
  Bad = "bad",
}
